import React from 'react';
import styled, { css } from 'styled-components';

import { convertThumbnailToPictureImage } from '@tager/web-modules';

import Picture from '@/components/Picture';
import Link from '@/components/Link';
import { media } from '@/utils/mixin';

import { CarsStockBannerProps } from './types';

function CarsStockBanner({
  image,
  url,
  isNewTab,
  isHorizontal,
}: CarsStockBannerProps) {
  return (
    <Component to={url} target={isNewTab ? '_blank' : '_self'}>
      <Image
        loading="lazy"
        isHorizontal={isHorizontal}
        desktop={convertThumbnailToPictureImage(image.desktop)}
        laptop={convertThumbnailToPictureImage(image.laptop ?? image.desktop)}
        tabletSmall={convertThumbnailToPictureImage(
          image.tablet ?? image.laptop ?? image.desktop
        )}
        mobile={convertThumbnailToPictureImage(
          image.mobile ?? image.tablet ?? image.laptop ?? image.desktop
        )}
      />
    </Component>
  );
}

export default CarsStockBanner;

const Component = styled(Link)`
  width: 100%;
`;

const Image = styled(Picture)<{
  isHorizontal?: boolean;
}>`
  width: 100%;
  height: 100%;

  ${media.mobile(
    css`
      padding-top: 138.894%;
    `
  )}

  ${({ isHorizontal }) =>
    isHorizontal &&
    css`
      padding-top: 23.394%;
    `}

  picture,
  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  img {
    object-fit: cover;
  }
`;
